import React from 'react';

function ErrorPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-900 text-white">
      <div className="text-center px-4 mb-6 max-w-2xl mx-auto">
        <h1 className="text-4xl md:text-6xl font-extrabold animate-gradient-text leading-tight mb-6">
          Oops! Something Went Wrong
        </h1>
        <p className="text-lg md:text-xl text-gray-300 mt-4">
          We encountered an issue while loading the data from the database. Please try again later.
        </p>
      </div>

      <div className="flex justify-center items-center">
        <img
          src="/errordb.png"
          alt="Something Went Wrong"
          className="w-full max-w-lg mb-6" 
        />
      </div>
    </div>
  );
}

export default ErrorPage;
